import { createSelector } from 'reselect';

import { RootState } from '../../reducers';
import { IngredientInOrder } from '../../entities/ingredients/ingredients.types';
import { Order } from '../../entities/orders/orders.types';

export const getSelectedIngredientInOrder = (state: RootState): IngredientInOrder[] =>
  state.application.orders.orderCreation.ingredientsInOrder;
export const getOrderIsEdit = (state: RootState): boolean => state.application.orders.orderCreation.orderIsEdit;
export const getIngredientIdToAddInOrder = (state: RootState): string | null =>
  state.application.orders.orderCreation.ingredientIdToAddInOrder;

export const getDeliveryPreview = (state: RootState) => state.application.orders.deliveryPreview;

export const getDeliveryIngredientReceiveData = createSelector(
  [getDeliveryPreview],
  (order: Order | null) => (index: number) => {
    if (!order || !order.items) return {};
    return order?.items[index]?.receiveData;
  },
);
